import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  ViewEncapsulation,
} from '@angular/core';
import {
  PrivacyStateService,
  SearchSubscriptionService,
} from '@immosky/shared';
import { AppParametersService } from '@immosky/types';
import { SearchSubscriptionAppParameters } from '../../services/search-subscription-app-parameters.service';

@Component({
  selector: 'app-desktop-wizard',
  templateUrl: './desktop-wizard.component.html',
  styleUrls: ['./desktop-wizard.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopWizardComponent {
  private acceptedRelevantCookies = false;

  @HostBinding('class.completed')
  wasSuccessful = false;

  get objectSearchUrl(): string {
    return this.appParametersService.get().objectSearchUrl;
  }

  get canSubmit(): boolean {
    return (
      this.searchSubscriptionService.isValid && this.acceptedRelevantCookies
    );
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private appParametersService: AppParametersService<SearchSubscriptionAppParameters>,
    private searchSubscriptionService: SearchSubscriptionService,
    private privacyStateService: PrivacyStateService
  ) {
    this.onLoaded();
  }

  private onLoaded = () => {
    if (document.readyState === 'complete') {
      this.privacyStateService.canSubmitForm.subscribe(
        (canSubmitForm: boolean) => {
          this.acceptedRelevantCookies = canSubmitForm;
          this.cdRef.markForCheck();
        }
      );
    } else {
      window.requestAnimationFrame(this.onLoaded);
    }
  };

  submit() {
    this.searchSubscriptionService.submitSearchSubscription(
      this.appParametersService.get().countries[0]
    );

    this.wasSuccessful = true;
  }
}
